module.exports = __webpack_public_path__ + "static/media/team-ashley.5da63911.jpg";